// extracted by mini-css-extract-plugin
export default {"main":"CardSlot_main__yYTUI","slot":"CardSlot_slot__Xd+T4","card":"CardSlot_card__Z1LYt","closeWrap":"CardSlot_closeWrap__aDLHE"};